import React from 'react';
import type { PurchaseCriticality, PurchaseRequestStatus } from '../api';
import { PURCHASE_STATUS_LABELS, PURCHASE_STATUS_STYLES } from './format';

export function PurchaseStatusBadge({ status }: { status: PurchaseRequestStatus }) {
  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${PURCHASE_STATUS_STYLES[status] ?? 'bg-gray-100 text-gray-700'}`}>
      {PURCHASE_STATUS_LABELS[status] ?? 'Estado operacional'}
    </span>
  );
}

const CRITICALITY: Record<PurchaseCriticality, { label: string; style: string }> = {
  low: { label: 'Baixa', style: 'bg-gray-100 text-gray-700' },
  medium: { label: 'Média', style: 'bg-blue-100 text-blue-700' },
  high: { label: 'Alta', style: 'bg-orange-100 text-orange-800' },
  critical: { label: 'Crítica', style: 'bg-red-100 text-red-800' },
};

export function CriticalityBadge({ criticality }: { criticality: PurchaseCriticality }) {
  const value = CRITICALITY[criticality] ?? CRITICALITY.medium;
  return <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${value.style}`}>{value.label}</span>;
}
